<template>
	<Modal
		title="Deal Events"
		:closeOnOverlayClick="false"
		:visible="modalVisible"
		@close="onClose"
	>
		<template v-slot:body>
			<div class="deal-events">
				<div class="deal-events__date">
					Desk created by {{ createdByName }} on
					{{ createdOnDate }} at
					{{ createdOnTime }}
				</div>

				<DealEventsTable class="deal-events__table" :dealId="dealId" />
			</div>
		</template>

		<template v-slot:footer>
			<ButtonSet>
				<template #default>
					<ButtonClassic
						variant="primary"
						labelText="OK"
						@click="onClose"
					/>
				</template>
			</ButtonSet>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/shells/modal/modal.vue';
import DealEventsTable from './deal-events-table.vue';
import ButtonSet from '@/components/forms/button/button-set.vue';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import { mapActions, mapGetters } from 'vuex';
import viewMixin from '@/mixins/view-mixin';

export default {
	name: 'DealEventsModal',
	mixins: [viewMixin],
	components: {
		Modal,
		DealEventsTable,
		ButtonSet,
		ButtonClassic
	},
	data() {
		return {
			modalVisible: false
		};
	},
	props: {
		dealId: {
			type: Number,
			required: true
		},
		visible: {
			type: Boolean,
			default: false
		}
	},
	async created() {
		if (this.visible) {
			await this.loadEvents();
		}
	},
	watch: {
		async visible(newValue) {
			if (newValue) {
				await this.loadEvents();
			} else {
				this.modalVisible = false;
			}
		}
	},
	methods: {
		...mapActions('deal', ['getDealEventsAction']),
		async loadEvents() {
			await this.getDealEventsAction({
				companyId: this.companyId,
				dealId: this.dealId
			});

			this.modalVisible = true;
			this.onReady();
		},
		onClose() {
			this.$emit('close');
		},
		onReady() {
			this.$emit('ready');
		}
	},
	computed: {
		...mapGetters('deal', ['dealEvents']),
		createdEvent() {
			//TODO: update from this.dealEvents where the action is R
			return {
				id: 1,
				scenarioId: 123,
				employeesId: 999,
				employeeName: 'Test User',
				actionName: 'Deal created',
				action: 'C',
				actionDate: '2019-01-04 14:46:59.833',
				dealNumber: '12345'
			};
		},
		createdByName() {
			//TODO: update to get from this.createdEvent
			return 'Jane Doe';
		},
		createdOnDate() {
			//TODO: update to get from this.createdEvent
			//use function to get local date from /utils/date-functions
			return '5/12/2023';
		},
		createdOnTime() {
			//TODO: update to get from this.createdEvent
			//use function to get local date from /utils/date-functions
			return '9:48 AM';
		}
	}
};
</script>

<style lang="scss" scoped>
.deal-events {
	width: 700px;

	&__date {
		font-size: $txt-font-size;
	}

	&__table {
		margin-top: $gutter-lg;
	}
}
</style>
